import { commonOverrides } from './base.js'

export const createDarkTheme = (given) => {
  const vars = { ...given }
  if (!vars.PRIMARY_COLOR) vars.PRIMARY_COLOR = '#8b5cf6'
  if (!vars.INFO_COLOR) vars.INFO_COLOR = '#38bdf8'
  if (!vars.SUCCESS_COLOR) vars.SUCCESS_COLOR = '#34d399'
  if (!vars.ERROR_COLOR) vars.ERROR_COLOR = '#fb7185'
  if (!vars.WARNING_COLOR) vars.WARNING_COLOR = '#f59e0b'
  if (!vars.BASE_COLOR) vars.BASE_COLOR = '#0f172a'
  if (!vars.TEXT_COLOR) vars.TEXT_COLOR = '#e2e8f0'
  if (!vars.BASE_INVERT_COLOR) vars.BASE_INVERT_COLOR = '#ffffff'

  return {
    common: commonOverrides(vars),
  }
}
